import DashboardController from './Dashboard/DashboardController'
import MenuProfileController from './menuProfile/menuProfileController'

export const Dashboard = DashboardController
export const MenuProfile = MenuProfileController
